var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNextBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.503,
    height: 23.616,
    viewBox: "0 0 13.503 23.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_119",
    "data-name": "Groupe 119",
    transform: "translate(-1432 -965.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_96",
    "data-name": "Groupe 96",
    transform: "translate(-370 443.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M20.679,18,11.742,9.07a1.681,1.681,0,0,1,0-2.384,1.7,1.7,0,0,1,2.391,0L24.258,16.8a1.685,1.685,0,0,1,.049,2.327L14.14,29.32a1.688,1.688,0,0,1-2.391-2.384Z",
    transform: "translate(1790.753 515.804)",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextBlack);
export default __webpack_public_path__ + "static/media/icon-next-black.7702844792eba721decc5b2027116ea0.svg";
export { ForwardRef as ReactComponent };